import React from "react";
import LogoCircle from "../images/LogoCircle.png";

// Create a custom Logo component
const Logo = () => (
  <div className='d-inline-block align-top'>
    <img
      src={LogoCircle}
      alt='Artist Showcase'
      className='img-fluid'
      style={{ width: "60px", height: "60px" }}
    />
  </div>
);

export default Logo;
